import { translate, DateFactory } from 'rhg-vue-common'
import { language } from '@/infrastructure/Configuration'

const DaysBeforeNoticeExpiration = 20

export default class Offer {
  static parse ({ ...rest }) {
    return new Offer({
      ...rest
    })
  }

  constructor ({ backCode, title, shortDescription, bookingEndDate, mainImage, detailPageUrl, displayPriceText }) {
    this.code = backCode
    this.title = title
    this.description = shortDescription
    this.expiration = {
      text: formatExpireDate(bookingEndDate),
      expiresSoon: determineIfExpiresSoon(bookingEndDate, DaysBeforeNoticeExpiration)
    }
    this.image = {
      src: mainImage?.url,
      alt: mainImage?.altText
    }
    this.badgeText = displayPriceText
    this.offerUrl = detailPageUrl
  }

  openSBCalendar() {
    localStorage.setItem('voucherBook', this.code)
    window.searchBarVue.$emit('bv::show::modal', 'search-modal')
  }
}

function formatExpireDate(date) {
  return translate(
    'paExpire',
    undefined,
    DateFactory.formatWithLocaleDate(
      date,
      DateFactory.DatePatterns.GENERAL,
      language.split('-')[0]
    )
  )
}

function determineIfExpiresSoon(date, daysBeforeNotice) {
  return DateFactory.daysBetween(DateFactory.now(), date) <= daysBeforeNotice
}
